
import Vue from 'vue'
import { Tooltip } from 'uiv'

export default Vue.extend({
   name: 'CheckboxComponent',
   props: {
      id: String,
      label: String,
      value: Boolean,
      description: String,
      tooltip: String,
      readonly: { type: Boolean, default: false },
   },
   data() {
      return {
         initialValue: false,
         innerValue: false,
         dirty: false,
      }
   },
   computed: {
      tooltipId(): string {
         return `tooltip-${this.id}`
      },
      tooltipTargetId(): string {
         return `#${this.tooltipId}`
      },
   },
   mounted() {
      this.innerValue = this.value
      this.initialValue = this.value
   },
   watch: {
      value(newValue: boolean) {
         if (newValue !== this.innerValue) {
            this.innerValue = newValue
            this.initialValue = newValue
         }
      },
   },
   methods: {
      onChange() {
         if (!this.dirty) {
            this.dirty = this.innerValue !== this.value
         }
         this.$emit('input', this.innerValue)
      },
   },
   components: {
      Tooltip,
   },
})
